// extracted by mini-css-extract-plugin
export var attachmentContainer = "_i7-0";
export var fileList = "_i7-2";
export var removeFileButton = "_i7-1";